import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { colors } from './theme';
import LoadingSpinner from './components/LoadingSpinner';

const API_BASE = process.env.REACT_APP_API_URL;

export default function BuildOrderDevicePage() {
  const { id } = useParams();
  const [device, setDevice] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/device/${id}`)
      .then(res => res.json())
      .then(setDevice)
      .catch(() => {});
  }, [id]);

  const updateProgress = async (section, value) => {
    if (!device) return;
    const newProgress = { ...device.progress, [section]: value };
    const res = await fetch(`${API_BASE}/device/${id}/progress`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ progress: newProgress }),
    });
    if (res.ok) {
      const updated = await res.json();
      setDevice(updated);
    }
  };

  if (!device) {
    return (
      <div className="ni-page">
        <div className="ni-shell ni-shell--narrow">
          <div className="ni-panel" style={loadingStyle}>
            <LoadingSpinner />
          </div>
        </div>
      </div>
    );
  }

  const progressOptions = ['idle', 'inprogress', 'complete'];

  return (
    <div className="ni-page">
      <div className="ni-shell ni-shell--narrow">
        <div className="ni-panel">
          <div className="ni-section-heading" style={{ marginBottom: '1rem' }}>
            <div>
              <h2 className="ni-section-title">Device {device.serialNumber}</h2>
              <p className="ni-section-copy">Product: {device.productNumber}</p>
            </div>
            <span className="ni-pill">{device.status}</span>
          </div>

          <div className="ni-panel ni-panel--dense" style={{ marginBottom: '1rem' }}>
            <h3 className="ni-section-title" style={{ fontSize: '1.2rem', marginBottom: '0.8rem' }}>Progress</h3>
            <div className="ni-grid ni-grid--two">
              {['subassy1', 'test'].map(sec => (
                <label key={sec} style={fieldStyle}>
                  <span>{sec}</span>
                  <select
                    value={device.progress?.[sec] || 'idle'}
                    onChange={e => updateProgress(sec, e.target.value)}
                    className="ni-select"
                  >
                    {progressOptions.map(o => (
                      <option key={o}>{o}</option>
                    ))}
                  </select>
                </label>
              ))}
            </div>
          </div>

          <div className="ni-panel ni-panel--dense">
            <h3 className="ni-section-title" style={{ fontSize: '1.2rem', marginBottom: '0.8rem' }}>Production Logs</h3>
            <ul style={logListStyle}>
              {device.productionLogs && device.productionLogs.length > 0 ? (
                device.productionLogs.map((log, idx) => (
                  <li key={idx} style={logItemStyle}>
                    {new Date(log.timestamp).toLocaleString()} - {log.message}
                  </li>
                ))
              ) : (
                <li style={logItemStyle}>No logs</li>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

const loadingStyle = {
  minHeight: '50vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const fieldStyle = {
  display: 'grid',
  gap: '0.45rem',
  color: colors.textBody
};

const logListStyle = {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  display: 'grid',
  gap: '0.6rem'
};

const logItemStyle = {
  padding: '0.85rem 0.9rem',
  borderRadius: '1rem',
  backgroundColor: colors.surface,
  color: colors.textBody,
  border: `1px solid ${colors.panelBorder}`
};
